import { Directive, ElementRef, Input, OnInit } from '@angular/core';

const SHOW_TRANSITION_CLASS = 'show-transition';
const HIDDEN_CLASS = 'hidden';

@Directive({
  selector: '[wzShowTransition]',
  standalone: false,
})
export class ShowTransitionDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.el.nativeElement.classList.add(SHOW_TRANSITION_CLASS);
  }

  @Input()
  set wzShowTransition(show: boolean) {
    if (show) {
      this.el.nativeElement.classList.remove(HIDDEN_CLASS);
    } else {
      this.el.nativeElement.classList.add(HIDDEN_CLASS);
    }
  }
}
